import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import { TitleCustomer } from "./Constant/Source";
import CustomerEditForm from "./Forms/CustomerEditForm";

const CustomerEdit: FC<EditProps> = props => {
  return (
    <Edit title={TitleCustomer.edit} component="div" {...props}>
      <CustomerEditForm {...props} />
    </Edit>
  );
};

export default CustomerEdit;
